import pako from 'pako'

export const compressSnapshot = (snapshot: any): number[] => {
  return Array.from(pako.gzip(new TextEncoder().encode(JSON.stringify(snapshot))))
}

export const decompressSnapshot = (compressedSnapshot: number[]) => {
  return JSON.parse(new TextDecoder().decode(pako.ungzip(new Uint8Array(compressedSnapshot))))
}
